import React, { useState, useEffect } from 'react';
import {
  SplitFactoryProvider,
  SplitTreatments,
  useSplitTreatments,
} from '@splitsoftware/splitio-react';

// UTILITY
import { allowAnalytic } from '@/index.js';
import { analyticsGetUserId } from '@/utility/analytics';
import { getSearchParams } from '@/utility/common';

// COMPONENTS
import Loader from '@/components/Loader';

const splitConfig = {
  core: {
    authorizationKey: process.env.REACT_APP_SPLIT_KEY,
    key: analyticsGetUserId() || 'default',
  },
  features: {
    results_view: 'off',
    results_bundle_learn_more_position: 'off',
    results_internet_option_position: 'off',
    subscription_btn_name: 'subscribe',
    results_bundle_learn_more_btn_name: 'learnMore',
    fmb_change_flow: 'regular',
    results_single_bundle_view: 'off',
  },
};

const withSplit = (names = [], attributes = {}) => WrappedComponent => {
  return (props = {}) => {
    const [anonymousId, setAnonymousId] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const params = getSearchParams(document.location.search);
    const showLT = params ? params.has('showLT') : false;

    useEffect(() => {
      const fetchAnonymousId = async () => {
        let count = 0;

        function setSegmentId(segmentId) {
          setAnonymousId(segmentId);
          splitConfig.core.key = segmentId;
          setIsLoading(false);
        }

        window.analytics.ready(() => {
          const segmentId = analyticsGetUserId();

          setSegmentId(segmentId);
        });

        const readyStateCheckInterval = setInterval(function() {
          const segmentId = analyticsGetUserId();

          if (segmentId) {
            setSegmentId(segmentId);
            clearInterval(readyStateCheckInterval);
          }

          if (count > 500) {
            setIsLoading(false);
            clearInterval(readyStateCheckInterval);
          }

          count++;
        }, 10);
      };

      if (allowAnalytic && window.analytics && !anonymousId) {
        fetchAnonymousId();
      } else {
        setIsLoading(false);
      }
    }, []);

    if (isLoading) return <Loader active fullFilled text={showLT ? 'Loading...' : ''} />;

    if (!names.length) {
      return (
        <SplitFactoryProvider config={splitConfig}>
          <WrappedComponent {...props} />
        </SplitFactoryProvider>
      );
    }

    return (
      <SplitFactoryProvider config={splitConfig}>
        <SplitTreatments names={names} attributes={attributes}>
          {splitProps => {
            return <WrappedComponent {...props} {...splitProps} />;
          }}
        </SplitTreatments>
      </SplitFactoryProvider>
    );
  };
};

export const withSplitTreatment = (names = []) => Component => {
  return props => {
    const splitProps = useSplitTreatments({ names });

    return <Component {...props} {...splitProps} />;
  };
};

export default withSplit;
